import { render, staticRenderFns } from "./BusinessTravellerEdit.vue?vue&type=template&id=5da9d0fb"
import script from "./BusinessTravellerEdit.vue?vue&type=script&lang=js"
export * from "./BusinessTravellerEdit.vue?vue&type=script&lang=js"
import style0 from "./BusinessTravellerEdit.vue?vue&type=style&index=0&id=5da9d0fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports